var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFolder48Filled = function SvgIconFolder48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4 37.7H13.6a5.31 5.31 0 0 1-5.3-5.3V15.6c0-2.92 2.38-5.3 5.3-5.3h4.1c1.24 0 2.44.44 3.39 1.23l4.53 3.77h8.79c2.92 0 5.3 2.38 5.3 5.3v11.8c0 2.92-2.38 5.3-5.3 5.3h-.01Z",
    fill: "current"
  })));
};
export default SvgIconFolder48Filled;